export default {
  numerarioSolicitacao: [],
  numerarioItens: [],
};
